<template>
    <div class="summary-page">
        <v-container fluid grid-list-xl class="general-container">
            <v-layout row wrap class="navigation-header">
                <v-flex xs12>
                    <header-bar></header-bar>
                </v-flex>
            </v-layout>

            <v-layout row wrap class="top-bar-no-margin">
                <v-flex xs12 class="top-bar-container padding-left-xxl padding-right-xxl">
                    <div>
                        <v-container fluid grid-list-xl class="alerts-info-top-bar">

                            <div class="top-bar-content layout">
                                <div class="page-title-container no-padding">
                                    <h2 class="page-title">{{text("api.summary.communication.title")}}</h2>
                                </div>
                                <div class="translation-selector-container no-padding">

                                    <div class="translation-selector">

                                        <div class="translation-selector__label">
                                            {{text("api.summary.communication.translate.label")}}
                                        </div>

                                        <div class="translation-selector__select">

                                            <div v-if="selectedTranslationLang !== ''"
                                                 @click="clearTranslation"
                                                 class="translation-selector__select__clear">
                                                <icon-clear class="translation-selector__select__clear__icon"></icon-clear>
                                            </div>

                                            <v-select
                                                attach
                                                :content-class="'translation-selector__select__content'"
                                                :items="languageListForDropdown"
                                                item-text="name"
                                                item-value="key"
                                                v-model="selectedTranslationLang"
                                                @input="loadTranslatedAssessment"
                                                hide-details
                                                class="translation-selector__select__input-group"
                                                :class="{ 'selected-option': selectedTranslationLang !== ''}"
                                            >
                                            </v-select>
                                        </div>

                                    </div>
                                </div>
                            </div>



                        </v-container>


                    </div>

                </v-flex>
            </v-layout>


            <v-layout class="summary-tabs-bar">
                <v-flex class="summary-tabs-container padding-left-xxl padding-right-xl no-padding-top">



                    <transition name="slide-fade">
                        <arrow-left-icon v-show="isTabsPrevIconVisible"
                                         @click.native="scrollTabs('prev')"
                                         :width="24"
                                         :height="24"
                                         svg-fill-class="svg-primary-color"
                                         class="summary-tabs-arrow-icon summary-tabs-arrow-icon--left"
                        ></arrow-left-icon>
                    </transition>

                    <!--
                        NOTE 1: "@hook:mounted" directive is not in the official documentation, but Evan You, the creator
                                of Vue, wrote in a post on Twitter that it's stable and quite safe to be used.
                                See https://twitter.com/youyuxi/status/981662220932313088
                        Note 2: We used `:next-icon="''"` and `:prev-icon="''"` to make sure that Vuetify doesn't mistakenly
                                add its default unwanted strings (font icons) over our custom svg arrow icons.
                    -->
                    <v-tabs v-if="datasummary"
                            ref="refSummaryTabs"
                            @hook:mounted="handleTabsMounted"
                            hide-slider
                            class="summary-tabs"
                            :value="0"
                            :next-icon="''" :prev-icon="''"
                    >

                        <v-tab v-for="(section, i) in sections"
                               v-if="datasummary[section.key] != null"
                               :key="'chapter-'+ section.key"
                               @click="scrollToSection(section.key)"
                               :ref="section.key"
                               class="summary-tabs__item"
                               :class="{
                               ['summary-tab-' + section.key]: true,
                               'activepanel': (section.key === crtActiveSectionKey)
                           }"
                        >
                            <span v-if="datasummary[section.key] != null && typeof datasummary[section.key].title !== 'undefined'">
                                <span class="summary-tabs__item__section-name">{{datasummary[section.key].title}}</span>
                                <span class="summary-tabs__item__section-name--translated" v-if="getSummaryDataTranslated"><br />({{getSummaryDataTranslated[section.key].title}})</span>
                            </span>
                        </v-tab>
                    </v-tabs>

                    <transition name="slide-fade">
                        <arrow-next-icon v-show="isTabsNextIconVisible"
                                         @click.native="scrollTabs('next')"
                                         :width="24"
                                         :height="24"
                                         svg-fill-class="svg-primary-color"
                                         class="summary-tabs-arrow-icon summary-tabs-arrow-icon--right"
                        ></arrow-next-icon>
                    </transition>



                </v-flex>
            </v-layout>



            <v-layout row>

                <v-flex ref="summaryPanelsContainer"
                        class="summary-content-panels-container scrolling-content-summary scrolling-content-summary-ie padding-left-xxl padding-right-xl">

                    <table v-if="datasummary"
                           class="summary-content-panels"
                           :class="{
                                'summary-translation-loaded': hasTranslatedSummaryData,
                                'two-cols-displayed': isDisplayedTwoColumns,
                                'small-display-mode': isSmallDisplayMode
                           }"
                           aria-label="Summary content panels"
                    >

                        <thead v-if="hasTranslatedSummaryData">

                            <!-- Small displays -->
                            <tr v-if="isSmallDisplayMode">
                                <th colspan="2" scope="col">

                                    <div class="float-left hidden-xs-only">
                                        <span>{{datasummary.texts['api.language.label']}} / {{getSummaryDataTranslated.texts['api.language.label']}}</span>
                                    </div>

                                    <div class="language-toggle-container">
                                        <div class="button-group">
                                            <button @click="expandOriginalLang"
                                                    class="button-group__item"
                                                    :class="{'button-group__item--active': (isExpandedOriginalLang && !isExpandedTranslatedLang)}">
                                                {{text("api.language.name." + datasummary.overview.assessmentLanguage.toLowerCase())}}
                                            </button>
                                            <button @click="expandTranslatedLang"
                                                    class="button-group__item"
                                                    :class="{'button-group__item--active': (isExpandedTranslatedLang && !isExpandedOriginalLang)}">
                                                {{text("api.language.name." + selectedTranslationLang)}}
                                            </button>

                                        </div>
                                    </div>
                                </th>
                            </tr>

                            <!-- Big displays -->
                            <tr v-else>
                                <transition name="slide-left">
                                    <th v-if="!isExpandedTranslatedLang"
                                        class="panel-container-original-lang"
                                        :class="{
                                            'column-expanded': isExpandedOriginalLang,
                                            'column-hidden': isExpandedTranslatedLang
                                        }"
                                        scope="col">

                                        <div class="summary-column-head-wrapper">

                                            <span @click="isExpandedOriginalLang = !isExpandedOriginalLang" class="btn-toggle-column">
                                                <icon-expand-column v-show="!isExpandedOriginalLang"></icon-expand-column>
                                                <icon-collapse-column v-show="isExpandedOriginalLang"></icon-collapse-column>
                                            </span>
                                            <span class="column-head-text">
                                                {{text("api.summary.communication.original.language.label")}}
                                                {{text("api.language.name." + datasummary.overview.assessmentLanguage.toLowerCase())}}
                                            </span>
                                        </div>

                                    </th>
                                </transition>
                                <transition name="slide-right">
                                    <th v-if="!isExpandedOriginalLang"
                                        class="panel-container-translated-lang"
                                        :class="{
                                            'column-expanded': isExpandedTranslatedLang,
                                            'column-hidden': isExpandedOriginalLang
                                        }"
                                        scope="col">

                                        <div class="summary-column-head-wrapper">
                                            <span @click="isExpandedTranslatedLang = !isExpandedTranslatedLang" class="btn-toggle-column">
                                                <icon-expand-column v-show="!isExpandedTranslatedLang"></icon-expand-column>
                                                <icon-collapse-column v-show="isExpandedTranslatedLang"></icon-collapse-column>
                                            </span>
                                            <span class="column-head-text">
                                                {{text("api.summary.communication.translate.to.label")}}
                                                {{text("api.language.name." + selectedTranslationLang)}}
                                            </span>
                                        </div>

                                    </th>
                                </transition>
                            </tr>
                        </thead>

                        <tbody>

                            <tr v-for="(section, i) in sections"
                                v-if="datasummary[section.key] != null"
                                :key="i+'-'+section.key"
                                :id="'section-row-'+section.key"
                                class="section-row">

                                <transition name="slide-left">
                                    <td v-if="!isExpandedTranslatedLang"
                                        class="panel-container-original-lang"
                                        :class="{
                                            'column-expanded': isExpandedOriginalLang,
                                            'column-hidden': isExpandedTranslatedLang
                                        }">
                                        <summary-content-panel v-if="datasummary"
                                                               :panelDataKey="section.key"
                                                               :datasummary="datasummary"
                                                               :isExpanded="section.isExpanded"
                                                               @onTogglePanel="toggleRow"
                                                               @onChangeSummaryVersion="loadAssessmentVersion"
                                        ></summary-content-panel>
                                    </td>
                                </transition>

                                <transition name="slide-right">
                                    <td v-if="!isExpandedOriginalLang"
                                        class="panel-container-translated-lang"
                                        :class="{
                                            'column-expanded': isExpandedTranslatedLang,
                                            'column-hidden': isExpandedOriginalLang
                                        }">
                                        <summary-content-panel v-if="getSummaryDataTranslated"
                                                               :panelDataKey="section.key"
                                                               panelKeySuffix="--translated"
                                                               :datasummary="getSummaryDataTranslated"
                                                               :isExpanded="section.isExpanded"
                                                               @onTogglePanel="toggleRow"
                                                               @onChangeSummaryVersion="loadAssessmentVersion"
                                        ></summary-content-panel>
                                    </td>
                                </transition>
                            </tr>

                        </tbody>


                    </table>

                </v-flex>

            </v-layout>


        </v-container>

        <v-footer app class="elevation-bg-color border-top-invisible">
            <v-layout row wrap class="padding-left-xxl padding-right-xxl">
                <v-flex xs12 class="summary-page-btns">

                    <span class="pdf-btn">
                        <v-btn v-if="(getAppPropertyValueArray('SHARING_CHANNELS', {mustUppercaseAll: true}).length > 0)"
                               @click="goToAssessmentSharePage"
                               class="footer-btn left-buttons btn-share color-headings-text"
                               flat> {{text('api.button.header.bar.share')}}</v-btn>
                    </span>
                    <span class="next-btn float-right" v-if="mustShowFooterBackBtn">
                        <v-btn flat @click="goToPreviousPage" class="footer-btn home color-headings-text">
                            <arrow-left-icon />
                            {{ text('api.button.back') }}
                        </v-btn>
                    </span>

                </v-flex>
            </v-layout>
        </v-footer>
        <accept-cookie></accept-cookie>

        <restricted-popup></restricted-popup>
        <print-pdf-popup></print-pdf-popup>
        <div class="cookies-display">
            <detect-browser-cookie></detect-browser-cookie>
        </div>
    </div>
</template>

<!-- ################################################################## -->

<script>
import {mapActions, mapGetters} from 'vuex';
import HeaderBar from '../shared/HeaderBar';
import TopBar from '../../../common/components/shared/TopBar';
import AssessmentAlerts from "../../../common/components/shared/AssessmentAlerts";
import PatientInfo from "../../../common/components/shared/PatientInfo";
import LabelPopup from '../../../common/components/shared/AddLabelTestPopup';
import AcceptCookie from '../../../professional/components/cookies/AcceptCookie';
import RestrictedPopup from '../../../common/components/shared/RestrictedPopup';
import PrintPdfPopup from '../scoring/ConfirmPrintPdfPopup';
import AssessmentPopup from '../scoring/SendAssessmentPopup';
import DetectBrowserCookie from "../../../common/components/cookies/DetectBrowserCookie";
import SummaryContentPanel from "./SummaryContentPanel";
import IconExpandColumn from "../../../common/components/svg/shared/IconExpandColumn";
import IconCollapseColumn from "../../../common/components/svg/shared/IconCollapseColumn";
import IconClear from "../../../common/components/svg/shared/IconClear";
import ArrowLeftIcon from "../../../common/components/svg/shared/arrowLeftIcon";
import ArrowNextIcon from "../../../common/components/svg/shared/arrowNextIcon";


export default {
        name: 'SummaryPage',
        components: {
            ArrowNextIcon,
            ArrowLeftIcon,
            HeaderBar,
            TopBar,
            AssessmentAlerts,
            PatientInfo,
            LabelPopup,
            AcceptCookie,
            RestrictedPopup,
            PrintPdfPopup,
            AssessmentPopup,
            DetectBrowserCookie,
            SummaryContentPanel,
            IconExpandColumn,
            IconCollapseColumn,
            IconClear,
        },

        data () {
            return {
                selectedTranslationLang: '',
                isExpandedOriginalLang: false,
                isExpandedTranslatedLang: false,

                sections: [
                    { key: 'overview', isExpanded: true },
                    { key: 'decision', isExpanded: true },
                    { key: 'scoring', isExpanded: true },
                    { key: 'startQuestions', isExpanded: true },
                    { key: 'generalQuestions', isExpanded: true },
                    { key: 'symptoms', isExpanded: true },
                    { key: 'sharedQuestions', isExpanded: true },
                ],

                crtActiveSectionKey: 'overview',

                isTabsPrevIconVisible: false,
                isTabsNextIconVisible: false,

                isScrollHandlerEnabled: true
            };
        },

        computed: {
            ...mapGetters({
                datasummary: 'SummaryStore/getSummaryDataNew',
                getSummaryDataTranslated: 'SummaryStore/getSummaryDataTranslated',
                getAppPropertyValueArray: 'TranslationStore/getAppPropertyValueArray',
                languageList: 'TranslationStore/getLanguageList',
            }),
            mustShowFooterBackBtn () {
                return (typeof this.$route.query.assessmentId !== "undefined" || (typeof this.$route.query.back !== "undefined" && this.$route.query.back === "true")) ? true : false;
            },
            mustShowFooter () {
                // Only display the footer when we need "Back" button to return to Assessments page or the "Share" button.
                return (this.mustShowFooterBackBtn || this.getAppPropertyValueArray('SHARING_CHANNELS', {mustUppercaseAll: true}).length > 0) ? true : false;
            },


            languageListForDropdown () {

                const originalSummaryLanguageKey = (this.datasummary !== null && this.datasummary.overview !== null && typeof this.datasummary.overview.assessmentLanguage !== "undefined")
                                                    ? this.datasummary.overview.assessmentLanguage.toLowerCase()
                                                    : "";

                let langsForDropdown = [{
                    key: "",
                    name: this.text("api.summary.communication.select.language")
                }];
                this.languageList.forEach((langKey) => {
                    if (langKey !== originalSummaryLanguageKey) {
                        langsForDropdown.push({
                            key: langKey,
                            name: this.text("api.language.name."+langKey)
                        });
                    }
                });

                return langsForDropdown;
            },

            isTranslationLangSelected() {
                return (this.selectedTranslationLang !== '') ? true : false;
            },

            hasTranslatedSummaryData() {
                return (this.getSummaryDataTranslated !== null) ? true : false;
            },

            isDisplayedTwoColumns() {
                return (this.hasTranslatedSummaryData && !this.isExpandedOriginalLang && !this.isExpandedTranslatedLang) ? true : false;
            },

            isSmallDisplayMode() {
                return (this.$vuetify.breakpoint.mdAndDown === true) ? true : false; // Use this consider "medium" size as small display too ("medium" included). For now we use this variant because of some content in columns/panels that cannot become too narrow.
            }
        },

        beforeCreate() {
            this.$store.commit('SummaryStore/resetStore');
            this.$store.commit('AssessmentAlertsStore/resetStore');
        },

        created () {
            let requestParams = this.buildSummaryRequestParams();
            this.loadSummaryData(requestParams).then(() => {

                if (typeof this.$route.query.translateLang !== "undefined") {
                    this.selectedTranslationLang = this.$route.query.translateLang;
                    this.loadTranslatedAssessment();
                }
                else {
                    this.$store.commit('SummaryStore/resetSummaryDataTranslated');
                }
            });
        }, // END created()

        mounted() {
            this.setupDisplayMode();

            this.$refs.summaryPanelsContainer.addEventListener('scroll', this.handleScroll);

            window.addEventListener('resize', this.refreshTabsArrowIcons);
        },

        beforeDestroy() {
            window.removeEventListener('resize', this.refreshTabsArrowIcons);
        },


        watch: {

            /**
             * This watch may be triggered on window resize, when conditions are met (when switching from small to big
             *     or from big to small display resolution).
             * We used this watch instead of a window 'resize' event listener because we don't need to run this code
             *     on each resize, we only need it when conditions are met, so we can just trust the value that vuetify
             *     gives us via isSmallDisplayMode() computed method.
             * @param newValue
             * @param oldValue
             */
            isSmallDisplayMode(newValue, oldValue) {
                this.setupDisplayMode();
            },
        },

        methods: {
            // Store actions.
            ...mapActions({
                showLabelPopup: 'TestStore/showAddLabelPopup',
                showSendAssessmentPopup: 'ScoringStore/showSendAssessmentPopup'
            }),

            buildSummaryRequestParams() {
                let params = {};

                // @TODO Query parameters may need some validation.

                if (typeof this.$route.query.assessmentId !== "undefined") {
                    params.assessmentId = this.$route.query.assessmentId;
                    if (typeof this.$route.query.msitat !== "undefined") {
                        params.msitat = this.$route.query.msitat;
                    }
                }
                else if (typeof this.$route.query.assessment !== "undefined" && typeof this.$route.query.version === "undefined") {
                    params = {
                        msitat: this.$route.query.msitat,
                        assessmentToken: this.$route.query.assessment,
                        assessmentVersion: null
                    };
                }
                else if (typeof this.$route.query.token !== "undefined") {
                    params = {
                        assessmentOldEmailToken: this.$route.query.token
                    };
                }
                else if (typeof this.$route.query.assessment !== "undefined" && typeof this.$route.query.version !== "undefined") {
                    params = {
                        assessmentToken: this.$route.query.assessment,
                        assessmentVersion: this.$route.query.version
                    };
                    if (typeof this.$route.query.msitat !== "undefined") {
                        params.msitat = this.$route.query.msitat;
                    }
                }

                return params;
            },

            loadSummaryData(requestParams) {
                return this.$store.dispatch('SummaryStore/loadSummaryDataNew', requestParams).then((response) => {
                    if (typeof response.data.data !== "undefined"
                        && typeof response.data.data.SUMMARY !== "undefined"
                        && typeof response.data.data.SUMMARY.overview !== "undefined") {
                        if (typeof response.data.data.SUMMARY.overview.assessmentToken !== "undefined") {
                            sessionStorage.setItem('proAssessmentToken', response.data.data.SUMMARY.overview.assessmentToken);
                        }
                        if (typeof response.data.data.SUMMARY.overview.assessmentVersion !== "undefined") {
                            sessionStorage.setItem('proAssessmentVersion', response.data.data.SUMMARY.overview.assessmentVersion);
                        }
                        if (typeof this.$route.query.msitat !== "undefined") {
                            sessionStorage.setItem('proMsitatForAssessmentShare', this.$route.query.msitat);
                        }
                    }
                });
            },

            loadAssessmentVersion(payload) {
                // We just suppose that the `payload` contains the request params already prepared to be immediately used for the API request.
                this.loadSummaryData(payload).then(() => {
                    this.loadTranslatedAssessment();
                });
            },

            // ==========================================
            // BEGIN Summary translation
            // ==========================================

            loadTranslatedAssessment() {

                // ----- No translation language selected.
                if (this.selectedTranslationLang === '') {
                    this.clearTranslation();
                    return;
                }

                // ----- There is a translation language selected, but it's the same as the original assessment language.
                // It doesn't make sense to translate to the same language, so we just clear the translation.
                // This case can occur when we navigate through assessment versions and the versions have different languages.
                const originalSummaryLanguageKey = (this.datasummary !== null && this.datasummary.overview !== null && typeof this.datasummary.overview.assessmentLanguage !== "undefined")
                    ? this.datasummary.overview.assessmentLanguage.toLowerCase()
                    : "";
                if (originalSummaryLanguageKey === this.selectedTranslationLang) {
                    this.clearTranslation();
                    return;
                }

                // ----- There is a translation language selected, so load the translation for it.

                let requestParams = this.buildSummaryRequestParams();
                requestParams.translationLanguage = this.selectedTranslationLang;


                this.$store.dispatch('SummaryStore/loadSummaryDataTranslated', requestParams).then(() => {
                    let routeParams = {...this.$route.query};
                    routeParams.translateLang = this.selectedTranslationLang;

                    this.setupDisplayMode();
                    this.refreshTabsArrowIcons();

                    this.$router.replace({name: 'SummaryPage', query: routeParams});
                });

            },

            clearTranslation() {
                this.isExpandedOriginalLang = false;
                this.isExpandedTranslatedLang = false;
                this.selectedTranslationLang = '';
                this.$store.commit('SummaryStore/resetSummaryDataTranslated');

                this.refreshTabsArrowIcons();

                // Remove "translateLang" parameter from URL.
                let routeParams = {...this.$route.query};
                delete routeParams.translateLang;
                this.$router.replace({name: 'SummaryPage', query: routeParams});
            },


            // ==========================================
            // END Summary translation
            // ==========================================

            goToPreviousPage() {
                if (typeof this.$route.query.assessmentId !== "undefined" || (typeof this.$route.query.back !== 'undefined' && this.$route.query.back === 'true')) {
                    if (typeof this.$route.query.msitat !== "undefined") {
                        this.$router.push('/assessment-list?msitat='+ this.$route.query.msitat +'&referral=summary');
                    }
                    else {
                        this.$router.push('/assessment-list?referral=summary');
                    }
                }
            },

            goToAssessmentSharePage() {
                // to="/assessment-share?referrer=summary"
                let queryParams = {
                    referrer: "summary"
                };

                /*
                @TODO Commented the following three lines of code because for the moment we (temporary) will use
                    sessionStorage ("proMsitatForAssessmentShare" key) for passing the "msitat" value.
                    We use sessionStorage in order to be consistent with assessment token and  assessment version,
                    which are passed through session storage too.
                    In the future we plan to pass assessment token, version and msitat through the url
                    as query params and at that moment the following lines will be uncommented.
                */
                /*if (typeof this.$route.query.msitat !== "undefined") {
                    queryParams.msitat = this.$route.query.msitat;
                }*/

                this.$router.push({
                    name: "AssessmentSharePage",
                    query: queryParams
                });
            },

            expandOriginalLang() {
                this.isExpandedTranslatedLang = false;
                this.isExpandedOriginalLang = true;
            },
            expandTranslatedLang() {
                this.isExpandedOriginalLang = false;
                this.isExpandedTranslatedLang = true;
            },

            toggleRow(payload) {
                const toggledSection = this.sections.find((section, i) => {
                    return (section.key === payload.sectionKey) ? true : false;
                });

                if (typeof toggledSection !== "undefined") {
                    toggledSection.isExpanded = payload.isExpanded;

                    let rowElement = document.querySelector(".summary-content-panels tr#section-row-" + payload.sectionKey);
                    if (rowElement !== null) {
                        if (payload.isExpanded === true) {
                            rowElement.classList.remove("section-row--collapsed");
                        }
                        else {
                            rowElement.classList.add("section-row--collapsed");
                        }
                    }
                }

                setTimeout(this.syncActiveTabWithSectionsScroll, 400); // We need this delay because of row toggle animation.
            },


            handleScroll() {
                if (this.isScrollHandlerEnabled === true) {
                    this.syncActiveTabWithSectionsScroll(); // Sync active tab with scroll.
                    this.scrollTabsHorizontallyToActiveTab(); // Make sure that in case the active tab is not visible, tab bar will be properly horizontally scrolled.
                }
            },

            scrollToSection(sectionKey) {

                this.crtActiveSectionKey = sectionKey;

                this.isScrollHandlerEnabled = false;

                const elemScrollableContainer = document.querySelector('.summary-content-panels-container');
                const elemColumnsHeadBar = document.querySelector('.summary-content-panels thead th');

                const elemTargetSectionRow = document.querySelector('.summary-content-panels #section-row-'+sectionKey);

                if (elemScrollableContainer && elemTargetSectionRow) {
                    const columnHeaderHeight = elemColumnsHeadBar ? elemColumnsHeadBar.offsetHeight : 0;
                    const newScrollPosition = elemTargetSectionRow.offsetTop - columnHeaderHeight - 20;

                    elemScrollableContainer.scrollTop = newScrollPosition;

                    this.scrollTabsHorizontallyToActiveTab();

                    setTimeout(() => {
                        this.isScrollHandlerEnabled = true;
                    }, 100);
                }
            },


            syncActiveTabWithSectionsScroll() {

                // ======= Sync active tab with scroll =======

                let elemContainer = this.$refs.summaryPanelsContainer;
                let allSectionRows = elemContainer.querySelectorAll('.summary-content-panels tr.section-row');

                for (let i = (allSectionRows.length-1); i >= 0; i--) {
                    let crtSectionRow = allSectionRows[i];
                    // A section row is considered active when it's top side is not lower than 200px below the top side of the scrolling container.
                    if ((elemContainer.scrollTop + 200) > (crtSectionRow.offsetTop)) {
                        this.crtActiveSectionKey = crtSectionRow.id.replace('section-row-', '');
                        break;
                    }
                }

                this.scrollTabsHorizontallyToActiveTab();
            },

            handleTabsMounted() {
                this.syncActiveTabWithSectionsScroll();
            },

            /**
             * Make sure that in case the active tab is not visible, tab bar will be properly horizontally scrolled.
             */
            scrollTabsHorizontallyToActiveTab() {
                let refSection = this.$refs[this.crtActiveSectionKey][0];
                const refSummaryTabs = this.$refs.refSummaryTabs;
                /**
                 * WARNING! The "tabClick" functions is not officially documented, so this code may not work anymore
                 *          if we will use another version of Vuetify. Current working Vuetify version is 1.0.5.
                 */
                refSummaryTabs.tabClick(refSection);

                this.refreshTabsArrowIcons();
            },

            /**
             * Show or hide tab's arrow icons, depending on the current horizontal scroll position of the tabs.
             */
            refreshTabsArrowIcons() {
                const refSummaryTabs = this.$refs.refSummaryTabs;

                /**
                 * WARNING! The "checkPrevIcon" and "checkNextIcon" functions are not officially documented,
                 *          so this code may not work anymore if we will use another version of Vuetify.
                 *          Current working Vuetify version is 1.0.5.
                 */

                if (typeof refSummaryTabs !== "undefined") {
                    this.isTabsPrevIconVisible = refSummaryTabs.checkPrevIcon();
                    this.isTabsNextIconVisible = refSummaryTabs.checkNextIcon();
                }

            },

            scrollTabs(direction) {
                const refSummaryTabs = this.$refs.refSummaryTabs;
                /**
                 * WARNING! The "scrollTo" functions is not officially documented, so this code may not work anymore
                 *          if we will use another version of Vuetify. Current working Vuetify version is 1.0.5.
                 */
                if (typeof refSummaryTabs !== "undefined" && typeof refSummaryTabs.scrollTo === "function") {
                    refSummaryTabs.scrollTo(direction);

                    this.refreshTabsArrowIcons();
                }
            },

            setupDisplayMode() {

                if (this.hasTranslatedSummaryData) {
                    if (this.isSmallDisplayMode) {
                        if (!this.isExpandedTranslatedLang === true) {
                            this.isExpandedOriginalLang = true;
                            this.isExpandedTranslatedLang = false;
                        }
                    }
                    else {
                        this.isExpandedOriginalLang = false;
                        this.isExpandedTranslatedLang = false;
                    }
                }
            },

        }

    }
</script>

<!-- ################################################################## -->

<style lang="scss" scoped>

    .container .layout.page-content.layout-summary-page {
        margin-bottom: 50px;

    }

    .card > .card__text {
        padding-left: 5px;
        border-top: 1px solid #efebeb;
    }

    .row-symptom-headline {

        background-color: $color-element-outline;
        font-weight: $font-weight-default;
        margin-bottom: -11px !important;
        color: $color-body-text;
    }

    .expansion-list {
        padding-bottom: 15px;
    }

    .margin-bottom-section {
        margin-bottom: 10px;
    }

    .margin-bottom-info > div > div {
        margin-bottom: 10px;
    }

    .headline-sections .display-section:first-of-type .row-symptom-headline{
        border-top-left-radius: 5px;
        border-top-right-radius: 5px;
    }


    .headline-sections .display-section:last-of-type .row-symptom-headline {
        border-bottom-left-radius: 5px;
        border-bottom-right-radius: 5px;
    }

    .symptom-name {
        margin-bottom: 10px;
    }

    .decisions-container .card>:first-child:not(.btn),
    .decisions-container .card > :last-child:not(.btn){
        border-top: none !important;
        border-bottom: none !important;
    }


    .container.grid-list-xl .layout .flex.scrolling-content-summary.scrolling-content-summary-ie {
        top: 213px;
        position: fixed;
        margin-left: auto;
        margin-right: auto;
        bottom: 60px;
        overflow: auto;
        padding-top: 0px;
    }

    @media only screen and (max-width: 600px) {
        .container.grid-list-xl .layout .flex.scrolling-content-summary.scrolling-content-summary-ie {
            top: 205px;
        }
    }

    .scrolling-content-summary.scrolling-content-summary-ie.summary-translated-lang {
        margin-left: 50%;
        border-left: 1px solid #d3d6d7;
    }


    .scrolling-content-summary.scrolling-content-summary-ie.no-footer {
        bottom: 0;
    }


    .scrolling-content-summary.scrolling-content-summary-ie p,
    .scrolling-content-summary.scrolling-content-summary-ie li {
        font-weight: $font-weight-default;
    }


    .clickclass {
        color: red !important;
    }

    .container.grid-list-xl .layout.page-content.layout-summary-page{
        margin-top: 0;
    }

    .section{
        margin-top: 5px;
    }

    .recommendationlist {
        list-style-type: disc;
        margin-left: 15px;
    }

    .scrolling-content-summary.scrolling-content-summary-ie p,
    .scrolling-content-summary.scrolling-content-summary-ie li {
        font-weight: $font-weight-default;
    }

    .symptom-name {
        margin-bottom: 15px;
    }


    .fitword {
        word-break: break-all;
    }

    .summary-translation-loaded {

        .summary-translated-lang.summary-translation-expanded {
            margin-left: 0;
        }

    }



</style>



// WEBPACK FOOTER //
// src/professional/components/summary/SummaryPage.vue